import { useState, useCallback, useEffect, useRef } from 'react';
import { useFlags, useLDClient } from 'launchdarkly-react-client-sdk';
import TeamsCapacity from '../../views/TeamsCapacity/TeamsCapacity';
import CapacityPage from '../../components/CapacityPage/CapacityPage';

const CapacityTab = () => {
  const ldClient = useLDClient();
  const { tasksAssignmentsBasedResourcesCapacity } = useFlags();
  const [shouldRender, setShouldRender] = useState<boolean>(false);
  const isMountedRef = useRef<boolean>(true);

  const init = useCallback(async () => {
    try {
      await ldClient?.waitForInitialization();
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Error initializing LaunchDarkly client', error);
    } finally {
      if (isMountedRef.current) {
        setShouldRender(true);
      }
    }
  }, [ldClient]);

  useEffect(() => {
    isMountedRef.current = true;
    init();
    return () => {
      isMountedRef.current = false;
    };
  }, [init]);

  if (!shouldRender) {
    return null;
  }

  if (tasksAssignmentsBasedResourcesCapacity) {
    return <TeamsCapacity />;
  }

  return <CapacityPage />;
};

export default CapacityTab;
